import { useMutation, useQueryClient } from "@tanstack/react-query";
// API
import API from "./Api";

const useEditInstallmentStatusApi = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, status, notes }) => {
      const response = await API.put(`/api/installment-requests/${id}`, { status, notes });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["installment-requests"]);
    },
  });
};

export default useEditInstallmentStatusApi;
